// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_2zo","requiredAsterisk":"Info_requiredAsterisk__2nNU6"};